// extracted by mini-css-extract-plugin
module.exports = {"messageCarousel":"MessageCarousel-module--messageCarousel--1Q1Hi","quote":"MessageCarousel-module--quote--7hZ0L"};